import clsx from "clsx"

interface Props {
  size?: "xxs" | "xs" | "sm" | "default" | "lg"
  className?: string
}

const Spinner = ({ size = "default", className }: Props) => (
  <div
    className={clsx(
      "flex shrink-0 animate-spin items-center justify-center rounded-full",
      className,
      {
        "h-2 w-2 border-[1.5px] border-current": size === "xxs",
        "h-3 w-3 border-2 border-current": size === "xs",
        "h-4 w-4 border-2 border-current": size === "sm",
        "h-6 w-6 border-[3px] border-current": size === "default",
      }
    )}
    style={{ borderRightColor: "transparent" }}
  />
)

export default Spinner
